function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from '../../../../_snowpack/pkg/react.js';
import { colors } from '../../../css/index.js';

function Percentage({
  size = 20,
  color = colors.green,
  strokeColor = colors.label,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M1.97036 17.529C1.23812 16.7967 1.23812 15.6095 1.97036 14.8773L14.8775 1.97016C15.6097 1.23793 16.7969 1.23793 17.5291 1.97017C18.2614 2.7024 18.2614 3.88958 17.5291 4.62182L4.622 17.529C3.88977 18.2612 2.70259 18.2612 1.97036 17.529Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3194 2.4121L2.4123 15.3192C1.92414 15.8074 1.92414 16.5989 2.4123 17.087C2.90045 17.5752 3.69191 17.5752 4.18006 17.087L17.0872 4.17987C17.5754 3.69172 17.5754 2.90026 17.0872 2.41211C16.599 1.92395 15.8076 1.92395 15.3194 2.4121ZM1.97036 14.8773C1.23812 15.6095 1.23812 16.7967 1.97036 17.529C2.70259 18.2612 3.88977 18.2612 4.622 17.529L17.5291 4.62182C18.2614 3.88958 18.2614 2.7024 17.5291 1.97017C16.7969 1.23793 15.6097 1.23793 14.8775 1.97016L1.97036 14.8773Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.37451C7.5 6.1004 6.10089 7.49951 4.375 7.49951C2.64911 7.49951 1.25 6.1004 1.25 4.37451C1.25 2.64862 2.64911 1.24951 4.375 1.24951C6.10089 1.24951 7.5 2.64862 7.5 4.37451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.375 6.87451C5.75571 6.87451 6.875 5.75522 6.875 4.37451C6.875 2.9938 5.75571 1.87451 4.375 1.87451C2.99429 1.87451 1.875 2.9938 1.875 4.37451C1.875 5.75522 2.99429 6.87451 4.375 6.87451ZM4.375 7.49951C6.10089 7.49951 7.5 6.1004 7.5 4.37451C7.5 2.64862 6.10089 1.24951 4.375 1.24951C2.64911 1.24951 1.25 2.64862 1.25 4.37451C1.25 6.1004 2.64911 7.49951 4.375 7.49951Z",
    fill: strokeColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 15.6245C18.75 17.3504 17.3509 18.7495 15.625 18.7495C13.8991 18.7495 12.5 17.3504 12.5 15.6245C12.5 13.8986 13.8991 12.4995 15.625 12.4995C17.3509 12.4995 18.75 13.8986 18.75 15.6245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.625 18.1245C17.0057 18.1245 18.125 17.0052 18.125 15.6245C18.125 14.2438 17.0057 13.1245 15.625 13.1245C14.2443 13.1245 13.125 14.2438 13.125 15.6245C13.125 17.0052 14.2443 18.1245 15.625 18.1245ZM15.625 18.7495C17.3509 18.7495 18.75 17.3504 18.75 15.6245C18.75 13.8986 17.3509 12.4995 15.625 12.4995C13.8991 12.4995 12.5 13.8986 12.5 15.6245C12.5 17.3504 13.8991 18.7495 15.625 18.7495Z",
    fill: strokeColor
  }));
}

export default /*#__PURE__*/forwardRef(Percentage);